export const degradedMode = {
	DEGRADED_BATTERY_FULL: '0',
	DEGRADED_MODE_ONE: '1',
	DEGRADED_MODE_TWO: '2',
	DEGRADED_BATTERY_EMPTY: '3',
};
